// extracted by mini-css-extract-plugin
export default {"svg":"AlertsLinkButton_svg__atJw1","div":"AlertsLinkButton_div__Ix-RU"};